import { render } from "./TopBarMenu.vue.js?vue&type=template&id=3becd7a7!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./TopBarMenu.vue?vue&type=template&id=3becd7a7"
import script from "./TopBarMenu.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./TopBarMenu.vue?vue&type=script&lang=js"
export * from "./TopBarMenu.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./TopBarMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__